import { type JsonDataItem } from '@g2u/ui-kit';
import { baseQuery } from '../baseQuery';

export const getCustomer = async ({ queryKey }: JsonDataItem) => {
  const { data } = await baseQuery(`customer?customerID=${queryKey[1]}`);

  return data.customer;
};
